import * as React from 'react';
import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';

export function RemarkDialog(props) {
  const { remarkValue, setRemarkValue, open, closeDialog, confirmAndCloseDialog } = props;
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(remarkValue);

  React.useEffect(() => {
    setInputValue(remarkValue);
  }, [open]);


  React.useEffect(() => {
    if (open) {
      confirmAndCloseDialog();
    }
  }, [remarkValue]);

  const onConfirm = () => {
    setRemarkValue(inputValue);
  };

  return (
    <Wrapper>
      <Dialog open={open} onClose={closeDialog} PaperProps={{ sx: { width: '70%', height: '280px' } }}>
        <DialogTitle>
          {t(translations.remark)}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            defaultValue={inputValue}
            multiline={true}
            rows={5}
            InputProps={{
              style: { fontSize: 14 },
            }}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={onConfirm}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .remark-input {

  }
`;
